// extracted by mini-css-extract-plugin
export default {"mainCard":"ManageAppoinment_mainCard__7imF0","textManage":"ManageAppoinment_textManage__VsoZm","icon":"ManageAppoinment_icon__R3JJr","divIcon":"ManageAppoinment_divIcon__JeP7I"};